

import { defineComponent } from 'vue';
import Mub from "@/components/Mub.vue";
import PrzPicture from '@/components/Muffin/Picture.vue';
import { BlockMedia } from '@/models/Blocks/Itens/block-item-media';
import { Picture } from '@/models/Muffin/picture';

export default defineComponent({
    name: 'ComboItem',
    components:{
        Mub,
        PrzPicture
    },
    props:{
        combo: {
            type: Object as any,
            default: () => { return undefined}
        }
    },
    computed:{
        transparentMode(){
            return !(this.combo?.listItemImages?.vertical??null);
        },
    },
    methods:{
        comboClick(){
            this.$emit("comboClick", this.combo);
        },

        getPicture(position: number):Picture|undefined{
            let media = new BlockMedia();
            let images: Array<any> = (position == 1 ? this.combo.listItemImages?.first : this.combo.listItemImages?.second) ?? [];
            if(images.length > 0){
                images.forEach((img) => {
                    media.addImage(img.url,img.condition,img.condition === null);
                });
            }
            if(media.images){
                media.images.title = position == 1 ? this.combo.firstProduct.name : this.combo.secondProduct.name;
            }
            return media.images??undefined;
        }
    }
});
